module.exports = __webpack_public_path__ + "img/租赁房_1@2x.429295a7.png";